export default __webpack_public_path__ + "static/media/rider-app.5d2d755f.png";